import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import { deliveryProofSectionStyles, geocodedAddressStyles, tabularSectionItemContentStyles, useSideModalCloseOpenStyles , tabularSectionCratesStyles, tagStyles, detailsContainer, timelineDotStyles, timelineConnectorStyles, timelineContentStyles, timelineBaseStyles, timelineItemStyles} from "SharedComponent/styles/sharedStyles";
import { useColorStyles } from "SharedComponent/styles/Colores.styles";


export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    titleContainer: {
      "& .headingContainer": {
        flexDirection: "column",
        "& .titleHeading": {
          fontSize: 18,
          fontWeight: 500,
          "& .content": {
            fontWeight: 600,
          },
        },
        "& .titleContent": {
          fontSize: 12,
          fontWeight: 600,
          margin: "auto 0px",
          "&.link": {
            cursor: "pointer",
          },
          "&.ORANGE": {
            color: COLORS.GOLDEN_BELL,
          },
          "&.SUCCESS_GREEN": {
            color: COLORS.PERSIAN_GREEN_DARK,
          },
        },
      },
      "& .tagContainer": {
        marginLeft: theme.spacing(1),
        "& .tag": {
          ...tagStyles(theme).base,
          ...useColorStyles(theme),
        },
      },
      "& .editIcon": {
        paddingLeft: theme.spacing(1),
        "& .icon": {
          cursor: "pointer",
          verticalAlign: "middle",
          fill: "none",
        },
        "& .refreshText": {
          color: COLORS.MYSTIC_GREY,
          fontSize: 12,
        },
        "& .refresh-block": {
          cursor: "default !important",
        },
      },
    },
    tabs: {
      paddingTop: "0px",
      paddingLeft: "0px",
      minHeight: "38px",
      "& .tabLabel": {
        fontSize: "14px",
        fontWeight: 700,
      },
    },
    contentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .tabValues": {
        padding: "8px 0px 0px 0px",
      },
      "& .geocodedAddress": {
        paddingBottom: theme.spacing(2),
        ...geocodedAddressStyles(theme),
      },
      ...detailsContainer(theme),
      "& .sellerDetails": {
        paddingTop: theme.spacing(1.75),
        "& .detailsHeader": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
       ...deliveryProofSectionStyles(theme),
      "& .consignmentHistory": {
        paddingBottom: theme.spacing(1),
      },
      "& .tabularSection": {
        paddingBottom: theme.spacing(1),
        "&:last-child": {
          paddingBottom: 0,
        },
        "&.crates": {
          ...tabularSectionCratesStyles(theme),
        },
        "& .itemDiv": {
          padding: theme.spacing(0),
          "& .content": {
           ...tabularSectionItemContentStyles(theme),
          },
        },
      },
    },
    accordionSummary: {
      "& .header": {
        fontSize: 14,
        fontWeight: 600,
        paddingBottom: theme.spacing(0.5),
        margin: "auto 0px",
        "&:last-child": {
          paddingBottom: 0,
        },
        "& .smallHeading": {
          fontSize: 12,
        },
      },
      "& .content": {
        flexGrow: 1,
      },
    },

    timeline: {
      ...timelineBaseStyles(),
      "& .timelineItem": {
        ...timelineItemStyles(),
        "& .lastModifiedContent": {
          fontSize: "12px",
          lineHeight: "10px",
          color: COLORS.DOVE_GRAY_DARK,
          paddingTop: "6px",
          "& .name": {
            marginLeft: "4px",
          },
        },
        "& .timelineDot": {
          ...timelineDotStyles(),
        },
        "& .timelineContentItem": {
          padding: "8px 0px",
        },
        "& .primaryConnector": {
          ...timelineConnectorStyles(),
        },
        "& .timelineContent": {
         ...timelineContentStyles(theme),
        },
      },
    },
    iconDownlod: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: 12,
      marginTop: "-24px",
      "& .icon": {
        fill: "none",
        width: "auto",
        height: "auto",
      },
    },
    accordionBundle: {
      flexGrow: 1,
      "&.MuiAccordion-root": {
        boxShadow: "none !important",
      },
      "& .header": {
        fontSize: 14,
        fontWeight: 600,
        paddingBottom: theme.spacing(0.5),
        "&:last-child": {
          paddingBottom: 0,
        },
        "& .smallHeading": {
          fontSize: 12,
        },
      },
      "& .content": {
        flexGrow: 1,
      },
    },
    dialogPaperPropsRoot: {
      margin: 0,
      marginLeft: "auto",
      maxHeight: "none",
      height: "100vh",
      width: 680,
    },
    checkbox: {
      marginLeft: "0px",
    },
    addressLabel: {
      fontSize: "12px",
      color: COLORS.PRIMARY_MAIN,
      lineHeight: "16px",
      fontWeight: 700,
      marginLeft: "12px",
    },
    confirmDialogPaperPropsRoot: {
      width: 338,
      height: 214,
      margin: "auto",
      borderRadius: theme.spacing(1),
    },
    confirmDialogContentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .contentItem": {
        "& p": {
          lineHeight: 1.2,
        },
        "&.heading": {
          "& p": {
            fontSize: 24,
            fontWeight: 600,
          },
        },
        "&.desc": {
          padding: theme.spacing(0, 2.5),
          "& p": {
            fontSize: 18,
            fontWeight: 400,
            "& .count": {
              fontWeight: 600,
            },
          },
        },
      },
    },
    confirmDialogButtonsContainer: {
      justifyContent: "center",
      "& .dialogBtn": {
        "&.primary": {
          marginLeft: theme.spacing(1),
        },
      },
    },
    verticalDiv: {
      color: "#0E5AA7",
      height: "16px",
      background: "#0E5AA7",
      width: "2px",
      margin: "2px 16px 0px 16px",
    },
    countSection: {
      margin: "auto",
      width: 100,
      height: 40,
      borderRadius: 100,
      backgroundColor: COLORS.FOOTER_COUNT_BACKGROUND,
      color: COLORS.WHITE,
      left: "calc(50% - 40px)",
      bottom: "38px",
      position: "fixed",
      zIndex: 100,
      "& .countContainer": {
        height: "100%",
        "& .countItem": {
          margin: "auto",
          "& p": {
            fontSize: 16,
            fontWeight: 400,
          },
          "& .current": {
            fontWeight: 500,
          },
          "& .separator": {
            padding: "0 2px",
          },
        },
      },
    },
    ...useSideModalCloseOpenStyles(),
    bundleProduct: {
      "& .icon": {
        fill: "none",
      },
      "& .bundleRows": {
        marginTop: 24,
        "& .itemContainer": {
          marginTop: 12,
          "&.rowItem": {
            "& p": {
              fontWeight: "400 !important",
            },
          },
        },
      },
    },
    itemHeader: {
      display: "flex",
      backgroundColor: COLORS.LIGHT_BLUE,
      width: "fit-content",
      padding: "4px 8px 2px 8px",
      borderRadius: 12,
    },
    rejectedReason: {
      textTransform: "capitalize",
      color: "#DD2326",
      fontSize: 8,
      padding: "0px 16px",
      marginTop: 8,
      "& p": {
        fontWeight: 400,
        fontSize: 12,
      },
    },
    accordianVerticalDiv: {
      color: "#0E5AA7",
      height: "16px",
      background: "#0E5AA7",
      width: "2px",
      margin: "auto 8px auto 8px",
    },
    titleContent: {
      fontSize: 12,
      fontWeight: 600,
      margin: "auto 0px",
      color: COLORS.PERSIAN_GREEN_DARK,
    },
    topLevelShieldCheckStyle: {
      margin: "auto 0px auto 8px",
      fill: COLORS.WHITE,
    },
    shieldCheckStyle: {
      margin: "auto 4px auto 0px",
      fill: COLORS.WHITE,
    },
  })
);
